var exports = {
  "kL": "xe533113f--b6b914--container",
  "I4": "xe533113f--b6b914--container--under-construction",
  "Kk": "xe533113f--b6b914--icon",
  "UU": "xe533113f--b6b914--name",
};

module.exports = exports;
